import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/imgs/upload_add1.png';
import _imports_1 from '@/assets/imgs/upload_add2.png';

const _withScopeId = n => (_pushScopeId("data-v-0488eb63"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "cms-module-title mg-t--25 mg-b--25"
};
const _hoisted_2 = {
  class: "tips"
};
const _hoisted_3 = {
  class: "upload-warp"
};
const _hoisted_4 = {
  key: 0,
  class: "upload-btn"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));

const _hoisted_6 = {
  class: "upload_btns"
};

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-shangchuan"
}, null, -1));

const _hoisted_8 = {
  class: "mg-l--5"
};
const _hoisted_9 = {
  class: "upload-tips"
};
const _hoisted_10 = {
  class: "cms-module-title mg-t--25 mg-b--25"
};
const _hoisted_11 = {
  class: "tips"
};
const _hoisted_12 = {
  class: "upload-warp"
};
const _hoisted_13 = {
  key: 0,
  class: "upload-btn"
};

const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));

const _hoisted_15 = {
  class: "upload_btns"
};

const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-shangchuan"
}, null, -1));

const _hoisted_17 = {
  class: "mg-l--5"
};
const _hoisted_18 = {
  class: "upload-tips"
};
const _hoisted_19 = {
  class: "cms-module-title mg-t--25 mg-b--25"
};
const _hoisted_20 = {
  class: "tips"
};
const _hoisted_21 = {
  class: "upload-warp"
};
const _hoisted_22 = {
  key: 0,
  class: "upload-btn-horizon"
};

const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1));

const _hoisted_24 = {
  class: "upload_btns"
};

const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-shangchuan"
}, null, -1));

const _hoisted_26 = {
  class: "mg-l--5"
};
const _hoisted_27 = {
  class: "upload-tips"
};
const _hoisted_28 = {
  key: 0
};
const _hoisted_29 = {
  key: 1,
  style: {
    "width": "100%"
  }
};

const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-shangchuan"
}, null, -1));

const _hoisted_31 = {
  class: "mg-l--5"
};
const _hoisted_32 = {
  style: {
    "display": "flex",
    "justify-content": "center"
  }
};
const _hoisted_33 = ["src", "alt"];
import FormTable from '@/components/FormTable/index.vue';
import ManuallyUpload from '@/components/Upload/ManuallyUpload.vue';
import ImageItem from '../../Components/ImageItem/index.vue';
import { inject } from 'vue';
import { useI18n } from 'vue-i18n';
import { validateImageUrl } from '@/utils/validate';
import { getItemByProp } from '@/utils/tools';
import PosterList from './posterList.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',

  setup(__props, {
    expose
  }) {
    const {
      t
    } = useI18n();
    const FormRef = ref(null);
    const imageItemRef = ref(null);
    const androidImageItemRef = ref(null);
    const horizonImageItemRef = ref(null);
    const posterObj = ref({
      visible: false,
      data: null,
      posterType: 'common'
    });

    const handleCheckChange = val => {
      formConfig.formData.type = val;
      formConfig.formData.url = '';
      formConfig.formData.file = [];
      formConfig.formData.base64Image = '';
    };

    const fileChange = file => {
      // 显示图标
      let reader = new FileReader(); //转base64

      reader.onload = function (e) {
        const res = e.target.result; // 将图片路径赋值给src

        formConfig.formData.file = [];
        formConfig.formData.file[0] = res;
        formConfig.formData.base64Image = res.split('base64,')[1];
        FormRef.value.mForm.validateField('file');
      };

      reader.readAsDataURL(file.raw);
    }; // 根据海报类型往对应的数组里添加数据


    const addImageIntoTargetList = (type, picList) => {
      switch (type) {
        case 'common':
          data.pictureList.push(...picList);
          break;

        case 'android':
          data.androidPictureList.push(...picList);
          break;

        case 'horizontal':
          data.horizonPictureList.push(...picList);
          break;
      }
    };

    const dialogConfig = reactive({
      visible: false,
      action: 'add',
      config: {
        title: '上传图片'
      },
      confirm: done => {
        let type = formConfig.formData.posterType;
        FormRef.value.mForm.validate(valid => {
          if (valid) {
            if (dialogConfig.action === 'add') {
              console.log('上传图片', formConfig.formData);
              addImageIntoTargetList(type, [{ ...formConfig.formData
              }]);
            } else if (dialogConfig.action === 'edit') {
              const {
                currentImgIndex
              } = data;

              if (formConfig.formData.type === 1) {
                formConfig.formData.url = '';
              } else {
                formConfig.formData.file = [];
              }

              switch (type) {
                case 'common':
                  data.pictureList[currentImgIndex] = { ...formConfig.formData
                  };
                  break;

                case 'android':
                  data.androidPictureList[currentImgIndex] = { ...formConfig.formData
                  };
                  break;

                case 'horizontal':
                  data.horizonPictureList[currentImgIndex] = { ...formConfig.formData
                  };
                  break;
              } // 同步修改父组件中的图片数据


              if (finishData.value.posterList && finishData.value.posterList.length > 0 && formConfig.formData.id) {
                let fItem = finishData.value.posterList.find(f => f.id == formConfig.formData.id);
                fItem ? fItem = { ...formConfig.formData
                } : '';
              }
            }

            dialogConfig.visible = false;
            done();
          } else {
            done();
          }
        });
      }
    });
    const finishData = inject('finishData');
    const languageOptions = inject('languageOptions');

    const getImageList = type => {
      let arr = [];

      if (finishData.value.posterList.length > 0) {
        finishData.value.posterList.forEach(item => {
          if (item.posterType == type) {
            arr.push({ ...item,
              type: item.type || 0
            });
          }
        });
      }

      console.log('拿图片', type, arr);
      return arr;
    };

    const data = reactive({
      imgVisible: false,
      dialogImageUrl: '',
      pictureList: getImageList('common'),
      androidPictureList: getImageList('android'),
      horizonPictureList: getImageList('horizontal'),
      currentImgIndex: -1,
      operationList: [{
        src: require('@/assets/imgs/pic_search.png'),
        action: item => {
          console.log('item182---', item);
          data.imgVisible = true;
          data.dialogImageUrl = item.url ? item.url : item.file[0];
        }
      }, {
        src: require('@/assets/imgs/pic_edit.png'),
        action: (item, index) => {
          data.currentImgIndex = index;
          formConfig.formData = { ...item
          };
          dialogConfig.visible = true;
          dialogConfig.action = 'edit';
          dialogConfig.config.title = '编辑';

          if (FormRef.value) {
            FormRef.value.mForm.clearValidate();
          }
        }
      }, {
        src: require('@/assets/imgs/pic_del.png'),
        action: (item, index) => {
          switch (item.posterType) {
            case 'common':
              data.pictureList.splice(index, 1);
              break;

            case 'android':
              data.androidPictureList.splice(index, 1);
              break;

            case 'horizontal':
              data.horizonPictureList.splice(index, 1);
              break;
          }
        }
      }],
      languageList: languageOptions,
      formPictureData: {
        url: ''
      },
      formAndroidPictureData: {
        url: ''
      },
      fromHorizonPictureData: {
        url: ''
      }
    });
    expose({
      data,
      imageItemRef,
      androidImageItemRef,
      horizonImageItemRef
    });
    const formConfig = reactive({
      formList: [[{
        label: '海报语言',
        prop: 'language',
        widgetType: 'Select',
        filterable: true,
        placeholder: '请选择语言',
        required: true,
        colspan: 3,
        valueKey: 'code',
        list: languageOptions
      }], [{
        label: '海报类型',
        prop: 'posterType',
        widgetType: 'Select',
        filterable: true,
        required: true,
        colspan: 3,
        list: []
      }], [{
        label: '添加方式',
        prop: 'type',
        widgetType: 'input',
        itemSlot: true,
        colspan: 3
      }], [{
        label: '图片URL',
        prop: 'url',
        widgetType: 'tooltipInput',
        required: true,
        colspan: 3,
        controller: (value, data, config) => data.type === 1 ? false : true
      }], [{
        label: '文件',
        prop: 'file',
        widgetType: 'text',
        itemSlot: true,
        required: true,
        fileType: ['png', 'jpg'],
        accept: ".png,.jpg",
        colspan: 3,
        controller: (value, data, config) => data.type === 1 ? true : false
      }]],
      formData: {
        // name: '',
        id: '',
        language: '',
        type: 1,
        url: '',
        file: [],
        base64Image: '',
        posterType: 'common'
      },
      rules: {
        language: [{
          required: true,
          message: t('请选择语言'),
          trigger: 'change'
        }],
        posterType: [{
          required: true,
          message: t('请选择海报类型'),
          trigger: 'change'
        }],
        url: [{
          required: true,
          validator: validateImageUrl,
          trigger: 'blur'
        }, {
          required: true,
          max: 512,
          message: t('限制字符数量', {
            num: '512'
          }),
          trigger: 'blur'
        }],
        file: [{
          required: true,
          message: t('请上传文件'),
          trigger: 'change'
        }]
      }
    });

    const showDialog = type => {
      formConfig.formData.posterType = type;
      dialogConfig.config.title = '上传图片';
      dialogConfig.action = 'add';
      dialogConfig.visible = true;
    };

    const handelRemove = file => {
      formConfig.formData.file = [];
      FormRef.value.mForm.validateField('file');
    };

    const onShowPosterList = posterType => {
      // 打开图库
      posterObj.value.visible = true;
      posterObj.value.posterType = posterType;
    }; // 图库选图


    const onPosterConfirm = row => {
      let type = posterObj.value.posterType;
      let pictureList = row.map(item => {
        return {
          type: 1,
          posterType: type,
          url: item.imageUrl,
          language: 'English'
        };
      });
      addImageIntoTargetList(type, pictureList);
    };

    watch(() => dialogConfig.visible, val => {
      if (!val) {
        setTimeout(() => {
          formConfig.formData = {
            // name: '',
            id: '',
            language: '',
            type: 1,
            url: '',
            file: [],
            base64Image: '',
            posterType: 'common' // 海报类型

          };
        }, 200);
      } else {
        let item = getItemByProp(formConfig.formList, 'posterType');

        switch (formConfig.formData.posterType) {
          case 'common':
            item.list = [{
              label: t('通用'),
              value: 'common'
            }];
            break;

          case 'android':
            item.list = [{
              label: t('安卓'),
              value: 'android'
            }];
            break;

          case 'horizontal':
            item.list = [{
              label: t('横版'),
              value: 'horizontal'
            }];
            break;
        }
      }

      if (FormRef.value) {
        FormRef.value.mForm.clearValidate();
      }
    }); // 下面三个监听器的作用： 为三种类型的海报赋值

    watch(() => data.pictureList, val => {
      if (val && val.length > 0) {
        data.formPictureData.url = val[0].url ? val[0].url : val[0].file[0];
        imageItemRef.value && imageItemRef.value.validateField('url');
      } else {
        data.formPictureData.url = '';
        imageItemRef.value && imageItemRef.value.validateField('url');
      }
    }, {
      immediate: true,
      deep: true
    });
    watch(() => data.androidPictureList, val => {
      if (val && val.length > 0) {
        data.formAndroidPictureData.url = val[0].url ? val[0].url : val[0].file[0];
        androidImageItemRef.value && androidImageItemRef.value.validateField('url');
      } else {
        data.formAndroidPictureData.url = '';
        androidImageItemRef.value && androidImageItemRef.value.validateField('url');
      }
    }, {
      immediate: true,
      deep: true
    });
    watch(() => data.horizonPictureList, val => {
      if (val && val.length > 0) {
        data.fromHorizonPictureData.url = val[0].url ? val[0].url : val[0].file[0];
        horizonImageItemRef.value && horizonImageItemRef.value.validateField('url');
      } else {
        data.fromHorizonPictureData.url = '';
        horizonImageItemRef.value && horizonImageItemRef.value.validateField('url');
      }
    }, {
      immediate: true,
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_checkbox = _resolveComponent("el-checkbox");

      const _component_FormItem = _resolveComponent("FormItem");

      const _component_MDialog = _resolveComponent("MDialog");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('通用海报')), 1), _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('图片大小建议在500kb以内。')), 1), _createElementVNode("div", _hoisted_3, [_createVNode(ImageItem, {
        imageTitle: "影片封面图",
        "img-list": data.pictureList,
        "operation-list": data.operationList
      }, null, 8, ["img-list", "operation-list"]), _createVNode(_component_el_form, {
        model: data.formPictureData,
        ref_key: "imageItemRef",
        ref: imageItemRef
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          prop: "url",
          rules: [{
            required: true,
            message: _ctx.$t('请上传封面图片'),
            trigger: 'change'
          }]
        }, {
          default: _withCtx(() => [data.pictureList.length < 5 ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_button, {
            type: "primary",
            plain: "",
            onClick: _cache[0] || (_cache[0] = $event => showDialog('common')),
            style: {
              "display": "block",
              "margin-bottom": "5px"
            }
          }, {
            default: _withCtx(() => [_hoisted_7, _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('点击上传')), 1)]),
            _: 1
          }), _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[1] || (_cache[1] = $event => onShowPosterList('common')),
            style: {
              "width": "109px",
              "margin": "0"
            }
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('图库选图')), 1)]),
            _: 1
          })]), _createElementVNode("div", _hoisted_9, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('影片封面图')), 1), _createElementVNode("span", null, _toDisplayString(_ctx.$t('尺寸')) + "：210*300px", 1)])])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["rules"])]),
        _: 1
      }, 8, ["model"])]), _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('安卓海报')), 1), _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('图片大小建议在500kb以内。')), 1), _createElementVNode("div", _hoisted_12, [_createVNode(ImageItem, {
        imageTitle: "影片封面图",
        "img-list": data.androidPictureList,
        "operation-list": data.operationList,
        imageSize: "630*900px"
      }, null, 8, ["img-list", "operation-list"]), _createVNode(_component_el_form, {
        model: data.formAndroidPictureData,
        ref_key: "androidImageItemRef",
        ref: androidImageItemRef
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          prop: "url",
          rules: [{
            required: false,
            message: _ctx.$t('请上传封面图片'),
            trigger: 'change'
          }]
        }, {
          default: _withCtx(() => [data.pictureList.length < 5 ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_hoisted_14, _createElementVNode("div", _hoisted_15, [_createVNode(_component_el_button, {
            type: "primary",
            plain: "",
            onClick: _cache[2] || (_cache[2] = $event => showDialog('android')),
            style: {
              "display": "block",
              "margin-bottom": "5px"
            }
          }, {
            default: _withCtx(() => [_hoisted_16, _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('点击上传')), 1)]),
            _: 1
          }), _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[3] || (_cache[3] = $event => onShowPosterList('android')),
            style: {
              "width": "109px",
              "margin": "0"
            }
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('图库选图')), 1)]),
            _: 1
          })]), _createElementVNode("div", _hoisted_18, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('影片封面图')), 1), _createElementVNode("span", null, _toDisplayString(_ctx.$t('尺寸')) + "：630*900px", 1)])])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["rules"])]),
        _: 1
      }, 8, ["model"])]), _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('横版海报')), 1), _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('图片大小建议在500kb以内。')), 1), _createElementVNode("div", _hoisted_21, [_createVNode(ImageItem, {
        imageTitle: "影片封面图",
        imageStyle: "width:414px;height: 222px",
        "img-list": data.horizonPictureList,
        "operation-list": data.operationList,
        imageSize: "1030*580px"
      }, null, 8, ["img-list", "operation-list"]), _createVNode(_component_el_form, {
        model: data.fromHorizonPictureData,
        ref_key: "horizonImageItemRef",
        ref: horizonImageItemRef
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          prop: "url",
          rules: [{
            required: false,
            message: _ctx.$t('请上传封面图片'),
            trigger: 'change'
          }]
        }, {
          default: _withCtx(() => [data.pictureList.length < 5 ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_hoisted_23, _createElementVNode("div", _hoisted_24, [_createVNode(_component_el_button, {
            type: "primary",
            plain: "",
            onClick: _cache[4] || (_cache[4] = $event => showDialog('horizontal')),
            style: {
              "display": "block",
              "margin-bottom": "5px"
            }
          }, {
            default: _withCtx(() => [_hoisted_25, _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t('点击上传')), 1)]),
            _: 1
          }), _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[5] || (_cache[5] = $event => onShowPosterList('horizontal')),
            style: {
              "width": "109px",
              "margin": "0"
            }
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('图库选图')), 1)]),
            _: 1
          })]), _createElementVNode("div", _hoisted_27, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('影片封面图')), 1), _createElementVNode("span", null, _toDisplayString(_ctx.$t('尺寸')) + "：1030*580px", 1)])])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["rules"])]),
        _: 1
      }, 8, ["model"])]), _createVNode(_component_MDialog, {
        autoLoading: "",
        modelValue: dialogConfig.visible,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => dialogConfig.visible = $event),
        nativeConfig: {
          closeOnClickModal: false,
          width: '600px'
        },
        dialogConfig: dialogConfig.config,
        onOnConfirm: dialogConfig.confirm
      }, {
        default: _withCtx(() => [_createVNode(FormTable, {
          ref_key: "FormRef",
          ref: FormRef,
          formRules: formConfig.rules,
          formData: formConfig.formData,
          col: ['30%', '70%']
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formConfig.formList, item => {
            return _openBlock(), _createBlock(_component_FormItem, {
              "form-item": item,
              "form-data": formConfig.formData
            }, {
              itemSlot: _withCtx(scope => [scope.prop === 'type' ? (_openBlock(), _createElementBlock("div", _hoisted_28, [_createElementVNode("div", null, [_createVNode(_component_el_checkbox, {
                "model-value": formConfig.formData.type === 1,
                onChange: _cache[6] || (_cache[6] = $event => handleCheckChange(1)),
                label: _ctx.$t('上传图片'),
                size: "large"
              }, null, 8, ["model-value", "label"]), _createVNode(_component_el_checkbox, {
                "model-value": formConfig.formData.type === 0,
                onChange: _cache[7] || (_cache[7] = $event => handleCheckChange(0)),
                label: _ctx.$t('输入URL'),
                size: "large"
              }, null, 8, ["model-value", "label"])])])) : _createCommentVNode("", true), scope.prop === 'file' ? (_openBlock(), _createElementBlock("div", _hoisted_29, [dialogConfig.visible ? (_openBlock(), _createBlock(ManuallyUpload, {
                key: 0,
                style: {
                  "width": "100%"
                },
                limit: 1,
                cover: "",
                fileType: scope.fileType,
                accept: scope.accept,
                onHandleChange: fileChange,
                onHandelRemove: handelRemove
              }, {
                default: _withCtx(() => [_createVNode(_component_el_button, {
                  type: "primary",
                  plain: ""
                }, {
                  default: _withCtx(() => [_hoisted_30, _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$t('点击上传')), 1)]),
                  _: 1
                })]),
                _: 2
              }, 1032, ["fileType", "accept"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]),
              _: 2
            }, 1032, ["form-item", "form-data"]);
          }), 256))]),
          _: 1
        }, 8, ["formRules", "formData"])]),
        _: 1
      }, 8, ["modelValue", "dialogConfig", "onOnConfirm"]), _createVNode(_component_el_dialog, {
        modelValue: data.imgVisible,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => data.imgVisible = $event),
        closeOnClickModal: false,
        title: _ctx.$t('预览')
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_32, [_createElementVNode("div", null, [_createElementVNode("img", {
          style: {
            "width": "100%",
            "height": "100%"
          },
          src: data.dialogImageUrl,
          alt: _ctx.$t('Preview Image')
        }, null, 8, _hoisted_33)])])]),
        _: 1
      }, 8, ["modelValue", "title"]), _createVNode(PosterList, {
        modelValue: posterObj.value.visible,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => posterObj.value.visible = $event),
        onInputImage: onPosterConfirm
      }, null, 8, ["modelValue"])]);
    };
  }

});